import React from 'react';
import { Box, Button, Typography, TextField } from '@mui/material';
import { useFormTheme } from '../../../contexts/FormThemeContext';  // Adjust the import path as necessary

const FieldVariantSettings = () => {
  const { fieldVariant, handleVariantChange } = useFormTheme();
  if (!fieldVariant) return null;

  const variants = [
    { name: 'Outlined', variant: 'outlined' },
    { name: 'Filled', variant: 'filled' },
    { name: 'Standard', variant: 'standard' },
  ];

  const handleVariantClick = (variant) => {
    handleVariantChange(variant);
  };

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'space-around',  // Ensures even spacing
      overflow: 'hidden',
      width: '100%'  // Takes full width of the container
    }}>
      {variants.map((variant, index) => (
        <Button
          key={variant.name}
          variant={fieldVariant === variant.variant ? 'contained' : 'outlined'}
          onClick={() => handleVariantClick(variant.variant)}
          sx={{
            width: '30%',  // Each button takes up a third of the space
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '4px', // Reduced padding
            textTransform: 'none',
          }}
        >
          <TextField
            label={variant.name}
            variant={variant.variant}
            disabled
            size="small" // Smaller TextField
            sx={{
              mb: 1, // Margin bottom for spacing between the preview and the text
              maxWidth: '90%', // Ensures the TextField does not overflow the button's width
              '& .MuiInputBase-root': {
                pointerEvents: 'none', // Makes the TextField not receive pointer events
                height: '40px', // Uniform height for all variants
                '&.Mui-disabled': {
                  '& fieldset': {
                    borderColor: 'rgba(0, 0, 0, 0.23)', // Ensures a visible border
                  },
                  '&:before': {
                    borderBottomStyle: 'solid', // Ensures a solid line for Standard variant
                  },
                },
              },
            }}
          />
          <Typography variant="caption">{variant.name}</Typography>
        </Button>
      ))}
    </Box>
  );
};

export default FieldVariantSettings;
